// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AlertAction, AlertActions, AlertSubImage } from '@shared/utils/Alert/AlertConstants';
import { DataCache } from '../DataCache';
import { Resources } from '@shared/localizations/Resources';
import { EventEmitter } from 'events';
export class AlertSideBarController {
    constructor() {
        this._eventEmitter = new EventEmitter();
    }
    // subscribe
    subscribeToAdd(callback) {
        this._eventEmitter.on('add', callback);
    }
    subscribeToUpdate(callback) {
        this._eventEmitter.on('update', callback);
    }
    subscribeToRemove(callback) {
        this._eventEmitter.on('remove', callback);
    }
    subscribeToEdit(callback) {
        this._eventEmitter.on('edit', callback);
    }
    // unsubscribe
    unsubscribeToAdd(callback) {
        this._eventEmitter.off('add', callback);
    }
    unsubscribeToUpdate(callback) {
        this._eventEmitter.off('update', callback);
    }
    unsubscribeToRemove(callback) {
        this._eventEmitter.off('remove', callback);
    }
    unsubscribeToEdit(callback) {
        this._eventEmitter.off('edit', callback);
    }
    subscribe() {
        DataCache.AlertManager.OnAlertAdded.Subscribe(this.alertAdded, this);
        DataCache.AlertManager.OnAlertRemoved.Subscribe(this.alertRemoved, this);
        DataCache.AlertManager.OnAlertUpdated.Subscribe(this.alertUpdated, this);
    }
    unsubscribe() {
        DataCache.AlertManager.OnAlertAdded.UnSubscribe(this.alertAdded, this);
        DataCache.AlertManager.OnAlertRemoved.UnSubscribe(this.alertRemoved, this);
        DataCache.AlertManager.OnAlertUpdated.UnSubscribe(this.alertUpdated, this);
    }
    alertAdded(alert) {
        this._eventEmitter.emit('add', alert);
    }
    alertRemoved(alert) {
        this._eventEmitter.emit('remove', alert);
    }
    alertUpdated(alert) {
        this._eventEmitter.emit('update', alert);
    }
    getAlerts() {
        const alertsArray = [];
        const alerts = DataCache.AlertManager.GetAllAlerts();
        const hideOE = Resources.isHidden('screen.Alerts.Action.PlaceOrder');
        for (let i = 0; i < alerts.length; i++) {
            const alert = alerts[i];
            const skipAdding = alert.Action === AlertAction.PLACE_ORDER_NOTIFY && hideOE;
            if (skipAdding) {
                continue;
            }
            alertsArray.push(alert);
        }
        alertsArray.sort(DataCache.AlertManager.SortAlertToId);
        return alertsArray;
    }
    onAlertActionButtonClick(alert, action) {
        if (action === AlertSubImage.PLAY_STOP) {
            DataCache.AlertManager.MakeAlertAction(alert, alert.Active ? AlertActions.STOP : AlertActions.START);
        }
        if (action === AlertSubImage.UPDATE) {
            this._eventEmitter.emit('edit', alert);
        }
        if (action === AlertSubImage.CLOSE) {
            DataCache.AlertManager.RemoveAlertProcess(alert);
        }
        return null;
    }
    static getCountAlerts() {
        return DataCache.AlertManager.GetActiveCount();
    }
    sortAlerts(array) {
        return array.sort(DataCache.AlertManager.SortAlertToId);
    }
}
